import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getSearchObject, parseQueryStringToObject } from 'Helpers/Uri';
import { getRouteByName } from 'Helpers/Routes';
import { trackEvent } from 'Helpers/Tracking';

import Head from 'Components/helpers/Head';
import HubspotForm from 'Components/public/hubspot/Form';
import Button from 'Components/layout/Button';

@connect(
    (state) => ({}), {}
)
export default class ContactSales extends React.Component {
    static propTypes = {
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            search: PropTypes.string
        }).isRequired
    };
    static defaultProps = {};


    componentDidMount = () => {
        const successMode = this.isSuccessMode(this.props);

        if (successMode) {
            const params = parseQueryStringToObject(this.props.location.search);
            trackEvent('enterpriseContact', {
                formId: '227b3e03-b479-45bc-8dee-dd9711c6d468',
                formName: 'Contact Sales',
                submissionGuid: params.submissionGuid
            });
        }
    }

    isSuccessMode = props => {
        const params = getSearchObject(props.location.search);
        if (params.hasOwnProperty('success') && params.success == 1) {
            return true;
        }

        return false;
    }

    render() {
        const successMode = this.isSuccessMode(this.props);

        return (
            <div className="container-contact-sales">
                <Head
                    title={`Contact Sales`}
                    description={`Original, legal, creative, crowdsourced branded User-Generated Content on demand for all content, branding, social media and marketing  channels`}
                    robots={`index, follow`}
                    canonical={getRouteByName('contactSales').path}
                />
                <div className="container-fluid">
                    <div className="form-container">
                        {successMode ?
                            <div className="success-info animated fadeIn">
                                <p className="success-text">Thank you. Our sales team will contact you in 24h.</p>
                                <Button element="anchor" layout="wide" to={getRouteByName('enterprise').path}>Return to Foap.com</Button>
                            </div>
                            :
                            <div>
                                <header className="contact-sales-header">
                                    <h1 className="contact-sales-headline">Tell us more about your brand</h1>
                                    <h2 className="contact-sales-subheadline">Submit a short brief so we can prepare a crowdsourced on-brand visual content ideas for you.</h2>
                                </header>
                                <HubspotForm id="227b3e03-b479-45bc-8dee-dd9711c6d468" />
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/global/ContactSales/index.js